import { AUTHENTICATION } from './Base';

export const onCreateRequest = (payload = {}, cb) => ({ payload, cb, type: AUTHENTICATION.CREATE_REQUEST });
export const onCreateFailure = (error = {}) => ({ error, type: AUTHENTICATION.CREATE_FAILURE });
export const onCreateSuccess = (payload = {}, token) => ({ payload, token, type: AUTHENTICATION.CREATE_SUCCESS });

export const onResetRequest = (payload = {}) => ({ payload, type: AUTHENTICATION.RESET_REQUEST });
